var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.7701 49.966)",
    style: {
      fill: "transparent"
    },
    cx: 49.9,
    cy: 50.1,
    rx: 22.7,
    ry: 22.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M49.9,25.8c-13.4,0-24.3,10.9-24.3,24.3c0,13.4,10.9,24.3,24.3,24.3c13.4,0,24.3-10.9,24.3-24.3 C74.2,36.7,63.3,25.8,49.9,25.8z M49.9,70.8c-11.4,0-20.7-9.3-20.7-20.7c0-11.4,9.3-20.7,20.7-20.7c11.4,0,20.7,9.3,20.7,20.7 C70.6,61.5,61.4,70.8,49.9,70.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M48.3,47.3l-0.1-10.9c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8l0.1,10.9l-0.3-0.1 C50.4,46.6,49.2,46.7,48.3,47.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M49.4,51.8c-0.9-0.4-1.3-1.4-0.9-2.3c0.4-0.8,1.4-1.3,2.3-0.9l13.8,6.1c0.9,0.4,1.3,1.4,0.9,2.3 c-0.4,0.8-1.4,1.3-2.3,0.9L49.4,51.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.920e2311.svg";
export { ForwardRef as ReactComponent };